<div class="form-field-label" *ngIf="label">
  {{ label }}
  <span class="form-field-label-tip" *ngIf="labelTip">{{ labelTip }}</span>
</div>

<app-form-control
  [control]="control"
  [errors]="errors"
  [markAsDirty]="markAsDirty"
>
  <div [ngClass]="grouped ? 'form-field-group' : 'form-field-control'">
    <ng-content></ng-content>
  </div>
</app-form-control>
